import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "rl-text-center"
};
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = {
  key: 1,
  class: "list"
};
const _hoisted_4 = {
  key: 0,
  class: "card-container rl-row-bottom-70"
};
const _hoisted_5 = {
  key: 1,
  class: "rl-row-bottom-20"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_row = _resolveComponent("el-row");
  const _component_group_card = _resolveComponent("group-card");
  const _component_video_card = _resolveComponent("video-card");
  return $props.errorMsg ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0,
    justify: "center",
    align: "middle",
    style: {
      "height": "calc(100vh - 300px)"
    }
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("p", {
      class: "rl-row-bottom-calc-30 rl-text-h3",
      innerHTML: $props.errorMsg,
      style: {
        "margin": "0",
        "color": "#909090"
      }
    }, null, 8, _hoisted_2)])]),
    _: 1
  })) : (_openBlock(), _createElementBlock("div", _hoisted_3, [$setup.state.groupCardInfo.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.groupCardInfo, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index
    }, [_createVNode(_component_group_card, {
      groupInfo: item,
      position: index,
      langPath: $props.langPath,
      impressionHandler: $props.impressionHandler,
      clickCardHandler: $props.clickCardHandler
    }, null, 8, ["groupInfo", "position", "langPath", "impressionHandler", "clickCardHandler"])]);
  }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: _normalizeClass(["card-container", {
      'flex-column': $props.viewMode === $setup.state.viewModeType.DETAILS
    }])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.displayVideoCards, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index
    }, [_createVNode(_component_video_card, {
      groupInfo: item,
      position: index,
      langPath: $props.langPath,
      viewMode: $props.viewMode,
      isShowVersionHeight: $setup.state.isShowVersionHeight,
      impressionHandler: $props.impressionHandler,
      clickCardHandler: $props.clickCardHandler,
      clickBookmarkHandler: $props.clickBookmarkHandler,
      isShowDeleteHistoryButton: $props.isShowDeleteHistoryButton,
      deleteHistoryHandler: $props.deleteHistoryHandler
    }, null, 8, ["groupInfo", "position", "langPath", "viewMode", "isShowVersionHeight", "impressionHandler", "clickCardHandler", "clickBookmarkHandler", "isShowDeleteHistoryButton", "deleteHistoryHandler"])]);
  }), 128))], 2), $setup.state.legacyVideoCards.length > 0 && $props.toExcludeLegacy ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("h2", {
    class: "legacy",
    onClick: _cache[0] || (_cache[0] = $event => $setup.state.isShowLegacy = !$setup.state.isShowLegacy)
  }, [_createElementVNode("span", null, [_cache[1] || (_cache[1] = _createTextVNode("Legacy   ")), _createElementVNode("i", {
    class: _normalizeClass(["fa fa-angle-right", {
      'open': $setup.state.isShowLegacy
    }])
  }, null, 2)])])])) : _createCommentVNode("", true), $setup.state.isShowLegacy ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: _normalizeClass(["card-container", {
      'flex-column': $props.viewMode === $setup.state.viewModeType.DETAILS
    }])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.legacyVideoCards, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index
    }, [_createVNode(_component_video_card, {
      groupInfo: item,
      position: index,
      viewMode: $props.viewMode,
      isShowVersionHeight: $setup.state.isShowVersionHeight,
      impressionHandler: $props.impressionHandler,
      clickCardHandler: $props.clickCardHandler,
      clickBookmarkHandler: $props.clickBookmarkHandler,
      isShowDeleteHistoryButton: $props.isShowDeleteHistoryButton,
      deleteHistoryHandler: $props.deleteHistoryHandler
    }, null, 8, ["groupInfo", "position", "viewMode", "isShowVersionHeight", "impressionHandler", "clickCardHandler", "clickBookmarkHandler", "isShowDeleteHistoryButton", "deleteHistoryHandler"])]);
  }), 128))], 2)) : _createCommentVNode("", true)]));
}